import { CallDispositionAction } from "@/enum/CallDispositionAction";
import { CallDispositionOutcome } from "@/enum/CallDispositionOutcome";
import type CallDisposition from "@/model/interface/CallDisposition";

const MAX_DISPOSITION_SHORTCUTS = 9;

export function dispositionShortcuts(
  dispositions: CallDisposition[],
  onSelect: (dispositionName: string) => void,
): Record<string, () => void> {
  return Object.fromEntries(
    dispositions
      .slice(0, MAX_DISPOSITION_SHORTCUTS)
      .map((disposition, index) => [String(index + 1), () => onSelect(disposition.name)]),
  );
}

export function dispositionShortcutKey(index: number): string | null {
  return index < MAX_DISPOSITION_SHORTCUTS ? String(index + 1) : null;
}

export const DISPOSITION_ACTION_LABELS: Record<CallDispositionAction, string> = {
  [CallDispositionAction.NONE]: "Nothing else",
  [CallDispositionAction.DO_NOT_CALL_NUMBER]: "Add the number to Do Not Call",
  [CallDispositionAction.WRONG_NUMBER]: "Mark the number as wrong",
  [CallDispositionAction.SCHEDULE_CALLBACK]: "Schedule a callback",
  [CallDispositionAction.REMOVE_FROM_CAMPAIGN]: "Remove the lead from the campaign",
};

export const DISPOSITION_ACTION_BADGES: Record<CallDispositionAction, string | null> = {
  [CallDispositionAction.NONE]: null,
  [CallDispositionAction.DO_NOT_CALL_NUMBER]: "Do Not Call",
  [CallDispositionAction.WRONG_NUMBER]: "Wrong number",
  [CallDispositionAction.SCHEDULE_CALLBACK]: "Callback",
  [CallDispositionAction.REMOVE_FROM_CAMPAIGN]: "Leaves campaign",
};

export const DISPOSITION_OUTCOME_LABELS: Record<CallDispositionOutcome, string> = {
  [CallDispositionOutcome.CONNECTED]: "Connected",
  [CallDispositionOutcome.NOT_CONNECTED]: "Not connected",
  [CallDispositionOutcome.NEUTRAL]: "Neither",
};
